module.exports = __webpack_public_path__ + "img/release-02.5cb240c0.png";